// A conflict is not an acknowledgement of this write. Verify the response body,
// not just HTTP 200 (an expired session/proxy can return a different document).
export async function isAuditSaveConfirmed(response, runId, count) {
    if (!response?.ok) return false;
    try {
        const data = await response.json();
        return data.ok === true && data.runId === runId && data.saved === count;
    } catch { return false; }
}


export function auditRunId(period, role) {
    return `batch-${period.year}-${period.monthFrom}-${period.monthTo}${role === 'auditor' ? '-auditor' : ''}`;
}
// Freeze the target revision before ERP reads; never repair a conflict by fetching a newer token.
export async function captureAuditBaseline(fetcher, period, role) {
    const runId = auditRunId(period, role);
    const response = await fetcher(`/api/proxy/audit/${encodeURIComponent(runId)}`);
    if (response.status === 404) return { runId, revisions: new Map() };
    if (!response.ok) throw new Error('Nie mozna sprawdzic wersji historii. Sprobuj ponownie.');
    const data = await response.json();
    if (data.ok !== true || !Array.isArray(data.results)) throw new Error('Invalid audit history response');
    return { runId, revisions: new Map(data.results.map(r => [r.identityId, r.revision])) };
}
export function auditWriteToken(baseline, identityId) {
    return { saveRunId: baseline.runId, expectedRevision: baseline.revisions.get(identityId) ?? null,
        mutationId: crypto.randomUUID() };
}
